export const textSizes = [
  {
    title: 20,
    text: 14,
  },
  {
    title: 20,
    text: 14,
  },
  {
    title: 17,
    text: 12,
  },
  {
    title: 17,
    text: 12,
  },
  {
    title: 17,
    text: 12,
  },
];

export const imageSizes = [
  [
    {
      height: 216,
      width: 222,
    },
    {
      height: 315,
      width: 175,
    },
  ],
  [
    {
      height: 216,
      width: 222,
    },
    {
      height: 315,
      width: 175,
    },
  ],
  [
    {
      height: 170,
      width: 175,
    },
    {
      height: 315,
      width: 175,
    },
  ],
  [
    {
      height: 170,
      width: 175,
    },
    {
      height: 315,
      width: 175,
    },
  ],
  [
    {
      height: 170,
      width: 175,
    },
    {
      height: 315,
      width: 175,
    },
  ],
];
